import React, { Component } from "react";
import { observer } from "mobx-react";
import "../styles/CustomerTourPage.less";
import PropTypes from "prop-types";

@observer
class BannerDesign extends Component {
  render() {
    const { activeItem, pages } = this.props;

    return (
      <div className="ui text container content">
        <h1 className="ui inverted header" style={{ marginTop: "10%" }}>
          <span className="ui big text" style={{ fontSize: "3rem" }}>
            {pages.length > 0 ? pages.map(page => (activeItem === page.slug ? page.title : "")) : null}
          </span>
        </h1>
      </div>
    );
  }
}

BannerDesign.propTypes = {
  activeItem: PropTypes.string.isRequired,
  pages: PropTypes.array.isRequired,
};

export default BannerDesign;
